import { render, staticRenderFns } from "./MobileAppBanner.vue?vue&type=template&id=2c9d444a&scoped=true"
import script from "./MobileAppBanner.vue?vue&type=script&lang=js"
export * from "./MobileAppBanner.vue?vue&type=script&lang=js"
import style0 from "./MobileAppBanner.vue?vue&type=style&index=0&id=2c9d444a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9d444a",
  null
  
)

export default component.exports